import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router';
import ErrorPage from '../util/ErrorPage';
import AccountDetails from '../Pages/AccountDetails';

const ClientMaintainanceRoutes = ({ props }) => {
  const { path } = useRouteMatch();

  return (
    <React.Fragment>
      <Switch>
        <Route exact path={path}>
          <AccountDetails />
        </Route>
        <Route path={`${path}`} component={AccountDetails} />
        <Route path="*" component={ErrorPage} />
      </Switch>
    </React.Fragment>
  );
};

export default ClientMaintainanceRoutes;
